export default "__VITE_ASSET__LnHCaD_B__"